export default function stretchByScroll(element, data) {
  let lastScrollY = window.scrollY;
  window.addEventListener("scroll", update, { passive: true });
  update();
  function update() {
    const scrollY = window.scrollY;
    element.classList.toggle("stretch", scrollY > 20);
    if (scrollY - lastScrollY > 50) {
      element.classList.add("down");
      lastScrollY = scrollY;
    } else if (lastScrollY - scrollY > 50) {
      element.classList.remove("down");
      lastScrollY = scrollY;
    }
  }
}
